/** @jsxImportSource @emotion/react */
import React, { useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { listItems } from '../../../../actions/Items/actions';
import apiClient from '../../../../constants/apiClient';
import { ROOT_URL } from '../../../../constants/urls';

const ExportCsv = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState("");
    const [selectedItemNumbers, setSelectedItemNumbers] = useState([]);
    const [isLNA, setIsLNA] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const items = useSelector(state => state.items.items);

    const Itemoptions = useMemo(() =>
        (items?.results || []).map(item => ({
            label: `${item.name}: ${item.item_number}`,
            value: item.item_id
        })), [items]);

    useEffect(() => {
        dispatch(listItems({ limit: 500, offset: 0, search: null }));
    }, [dispatch]);

    const formatDateToISO = (date) => {
        if (!date) return null;

        // Create a Date object with local timezone
        const localDate = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );

        // Convert to ISO string with timezone offset
        return localDate.toISOString();
    }

    const handleItemChange = (selectedOptions) => {
        setSelectedItemNumbers(selectedOptions || []);
    };

    const exportCSV = async () => {
        try {
            setIsLoading(true);
            const itemsToExport = (selectedItemNumbers || []).map(item => item.value);

            const response = await apiClient.post(
                `${ROOT_URL}api/export/csv`,
                {
                    startDate: startDate ? formatDateToISO(startDate) : null,
                    endDate: endDate ? formatDateToISO(endDate) : null,
                    status,
                    selectedItemNumbers: itemsToExport,
                    isLNA,
                },
                {
                    responseType: 'blob'
                }
            );

            const fileName = 'export.csv';
            const blob = new Blob([response.data], { type: 'text/csv' });
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Failed to export CSV', error);
            alert('Failed to export CSV. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container mt-5">
            <div className="mb-3 row">
                <label className="form-label col-md-2">Start Date:</label>
                <div className="col-md-10">
                    <DatePicker
                        className="form-control"
                        selected={startDate}
                        onChange={date => setStartDate(date)}
                        dateFormat="yyyy/MM/dd"
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                    />
                </div>
            </div>
            <div className="mb-3 row">
                <label className="form-label col-md-2">End Date:</label>
                <div className="col-md-10">
                    <DatePicker
                        className="form-control"
                        selected={endDate}
                        onChange={date => setEndDate(date)}
                        dateFormat="yyyy/MM/dd"
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                    />
                </div>
            </div>
            <div className="mb-3 row">
                <label className="form-label col-md-2">Status:</label>
                <div className="col-md-10">
                    <select className="form-select" value={status} onChange={e => setStatus(e.target.value)}>
                        <option value="">Select Status</option>
                        <option value="open">OPEN</option>
                        <option value="accepted">ACCEPTED</option>
                        <option value="declined">DECLINED</option>
                        <option value="status4">ALL</option>
                    </select>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="form-label col-md-2">LNA:</label>
                <div className="col-md-10 d-flex align-items-center ps-4">
                    <input
                        type="checkbox"
                        className="form-check-input me-2"
                        id="lnaCheckbox"
                        checked={isLNA}
                        onChange={e => setIsLNA(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="lnaCheckbox">True</label>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="form-label col-md-2">Item Numbers:</label>
                <div className="col-md-10">
                    <Select
                        isMulti
                        value={selectedItemNumbers}
                        options={Itemoptions}
                        onChange={handleItemChange}
                        isDisabled={isLoading}
                    />
                </div>
            </div>
            <div className="mb-3 d-flex gap-2">
                <button
                    className="btn btn-primary me-2"
                    onClick={() => exportCSV()}
                    disabled={isLoading}
                >
                    {isLoading ? 'Exporting...' : 'Export .csv'}
                </button>

            </div>
        </div>
    );
}

export default ExportCsv;